import { createSlice, PayloadAction, SerializedError } from '@reduxjs/toolkit';
import { fetchEpisodePageThunk, initializeEpisodesViewThunk } from './thunks';
import { EpisodesView } from './types';
import { getErrorFromErrorName } from '../../client/error/errorUtils';

function getRejectedReducer() {
  return (
    _state: unknown,
    action: PayloadAction<unknown, string, unknown, SerializedError>
  ) => {
    throw getErrorFromErrorName(
      action.error.name ?? 'UnknownError',
      action.error.message
    );
  };
}

const episodesViewsSlice = createSlice({
  name: 'episodes',
  initialState: {} as { [itemId: string]: EpisodesView },
  reducers: {},
  extraReducers(builder) {
    builder.addCase(
      initializeEpisodesViewThunk.fulfilled,
      (state, { payload }) => {
        if (!payload) return;
        const existing = state[payload.itemId];
        if (existing) return;

        state[payload.itemId] = payload;
      }
    );

    builder.addCase(initializeEpisodesViewThunk.rejected, getRejectedReducer());

    builder.addCase(fetchEpisodePageThunk.fulfilled, (state, { payload }) => {
      if (!payload) return;

      payload.forEach(episode => {
        const { viewId, seasonIndex, listIndex, episodeIndex } = episode;

        const episodeSlot =
          state[viewId]?.seasons[seasonIndex]?.lists[listIndex]?.episodes[
            episodeIndex
          ];

        if (!episodeSlot) return;
        episodeSlot.data = episode.data;
      });
    });

    builder.addCase(fetchEpisodePageThunk.rejected, getRejectedReducer());
  },
});

export default episodesViewsSlice.reducer;
